export default {
    depthChart(state) {
        return state.depthChart;
    },
    error(state) {
        return state.error;
    }
};
